/* eslint-disable no-console */
/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-one-expression-per-line */
import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  useMemo,
} from 'react';

import { useTransition } from 'react-spring';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { ColorResult, RGBColor } from 'react-color';
import 'react-toastify/dist/ReactToastify.css';
import Modal from 'react-modal';
import Select, { OptionTypeBase } from 'react-select';
import { IMaskInput } from 'react-imask';

import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, {
  Mousewheel,
  Navigation,
  Scrollbar,
  FreeMode,
} from 'swiper';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import { useFight } from '../../hooks/Fight';
import { useActions } from '../../hooks/Actions';
import { useSocketV2Instance } from '../../hooks';
import { sendAction } from '../../services/actions/action-sender';
import { useVisibleItems } from '../../hooks/useVisibleItems';

import StatContainer from '../../components/Stats';
import LogLine from '../../components/LogLine';
import Stopwatch from '../../components/Stopwatch';

import {
  Container,
  FightContainer,
  FightDataContainer,
  LogsContainer,
  ColorContainer,
  ModalContent,
  ModalTitle,
  ConfirmCheckbox,
} from './styles';
import Button from '../../components/Button';
import { useAuth } from '../../hooks/Auth';
import Badge from '../../components/Badge';
import { useHeader } from '../../hooks/Header';
import { useKeys, useModalGate } from '../../hooks/ActionKeys';

import { FightAction, FightRequest, initData } from '../../models/fight';
import labels from '../../utils/labels';
import { toLegacyFightId } from '../../utils/legacyId';
import {
  outcomeOfCorner,
  resolveWinner,
  winnerNewIdFromAction,
} from '../../utils/fightResult';
import { cornerOfDomainKey } from '../../utils/fightKeys';
import {
  getFinishCategory,
  getFinishTypeLabel,
  getFinishTypesForSport,
  toFinishTypeOption,
} from '../../utils/finishTypes';
import fightApiV2 from '../../services/fightApiV2';
import { toast } from 'react-toastify';
import io from 'socket.io-client';
SwiperCore.use([Scrollbar]);

interface ScoutProps {
  match: {
    params: {
      id: string;
    };
  };
}

interface CornerRecord {
  id: number | string | undefined;
  wins?: number;
  losses?: number;
  draws?: number;
  winsKoTko?: number;
  winsSubmission?: number;
  winsDecision?: number;
  lossesKoTko?: number;
  lossesSubmission?: number;
  lossesDecision?: number;
}

interface Option extends OptionTypeBase {
  label: any;
  value: any;
}

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    background: '#fff',
    // 'z-index': '100',
    width: '50%',
    maxWidth: '800px',
    minWidth: '600px',
    // height: '60%',
    color: '#111',
    display: 'flex',
    'flex-direction': 'column',
    'justify-content': 'space-around',
    borderRadius: '16px',
  },
  overlay: {
    background: 'rgba(49, 46, 56, 0.80)',
  },
};

const groundColor: RGBColor = {
  r: 198,
  g: 47,
  b: 255,
  a: 1,
};
const standingColor: RGBColor = {
  r: 255,
  g: 171,
  b: 7,
  a: 1,
};
const fenceColor: RGBColor = {
  r: 169,
  g: 94,
  b: 19,
  a: 1,
};
const trueColor: RGBColor = {
  r: 8,
  g: 185,
  b: 89,
  a: 1,
};
const neutroColor: RGBColor = {
  r: 107,
  g: 121,
  b: 151,
  a: 1,
};
const falseColor: RGBColor = {
  r: 255,
  g: 141,
  b: 7,
  a: 1,
};
const actionsToIgnore = ['significantStrike', 'totalStrike'];

const Stats: React.FC<ScoutProps> = ({ match }) => {
  Modal.setAppElement('body');
  const [modalIsOpen, setIsOpen] = useState(false);
  const [modalRoundIsOpen, setRoundIsOpen] = useState(false);

  const {
    fightEnd,
    handleCloseModalFightEnd,
    emitFightEnd,
    resetRequested,
    openResetModal,
    handleCloseModalReset,
    emitReset,
  } = useKeys();

  /** O checkbox precisa nascer desmarcado a cada abertura — senão a segunda
   * confirmação já viria aprovada, que é justamente o que ele evita. */
  const [resetConfirmed, setResetConfirmed] = useState(false);

  useEffect(() => {
    if (resetRequested) setResetConfirmed(false);
  }, [resetRequested]);

  // Os modais de fim de luta e de reset já se registram no KeyProvider; estes
  // dois são estado local da página e precisam avisar para bloquear o teclado.
  useModalGate('result', modalIsOpen);
  useModalGate('round', modalRoundIsOpen);
  // const [socket, setSocket] = useState<SocketIOClient.Socket>();
  // useEffect((): any => {
  //   const newSocket = io(process.env.REACT_APP_MIKE_API);
  //   setSocket(newSocket);
  // }, []);
  const [winner, setWinner] = useState<Option | null | undefined>(undefined);
  const [finishType, setFinishType] = useState<Option | null | undefined>(
    undefined,
  );
  const [resultAction, setResultAction] = useState<FightAction>(
    {} as FightAction,
  );
  /**
   * Trava de reentrância do salvamento do resultado. `useRef` porque o guard
   * precisa valer no mesmo tick: dois cliques no botão gravavam duas actions
   * antes de qualquer re-render. O state é só para desabilitar o botão.
   */
  const savingResult = useRef(false);
  const [isSavingResult, setIsSavingResult] = useState(false);

  const [redCornerColor, setRedCornerColor] = useState<RGBColor>({
    r: 255,
    g: 99,
    b: 132,
  });

  const [blueCornerColor, setBlueCornerColor] = useState<RGBColor>({
    r: 54,
    g: 162,
    b: 235,
  });

  const { actions, dispatchAction } = useActions();
  const isFinishedFight = useMemo(
    () => actions.some((action) => action.name === 'fightResult'),
    [actions],
  );


  const filteredActions = useMemo(() => {
    return actions.filter((action) => !actionsToIgnore.includes(action.name));
  }, [actions]);

  const {
    fight,
    translateCurrentRoundTime,
    updateFight,
    dispatchFight,
    getFight,
    getRoundTimeInSeconds,
  } = useFight();
  const { token } = useAuth();
  const { dispatchHeader } = useHeader();

  // const { emit: emitV1, isConnected: isConnectedV1 } = useSocketV1Instance();
  const {
    isConnected: isConnectedV2,
    joinEventWithAck: joinEventWithAckV2,
  } = useSocketV2Instance();

  const totalActions = filteredActions.length;
  const visibleItemsOptions = useMemo(
    () => ({
      bufferSize: 5,
      rootMargin: '300px',
      threshold: 0,
    }),
    [],
  );
  const { visibleIndices, setItemRef } = useVisibleItems(
    totalActions,
    visibleItemsOptions,
  );

  const [, setRenderedItems] = useState<Set<string>>(new Set());

  const visibleIndicesString = useMemo(() => {
    return Array.from(visibleIndices)
      .sort((a, b) => a - b)
      .join(',');
  }, [visibleIndices]);

  const visibleIndicesArray = useMemo(() => {
    return visibleIndicesString.split(',').filter(Boolean).map(Number);
  }, [visibleIndicesString]);

  const actionsIdsMap = useMemo(() => {
    const map = new Map<number, string>();
    filteredActions.forEach((action, index) => {
      if (action?._id) {
        map.set(index, String(action._id));
      }
    });
    return map;
  }, [filteredActions]);

  useEffect(() => {
    if (visibleIndicesArray.length === 0) {
      return;
    }
    setRenderedItems((prev) => {
      let hasChanges = false;
      const newSet = new Set(prev);
      visibleIndicesArray.forEach((index) => {
        const actionId = actionsIdsMap.get(index);
        if (actionId && !newSet.has(actionId)) {
          newSet.add(actionId);
          hasChanges = true;
        }
      });
      return hasChanges ? newSet : prev;
    });
  }, [visibleIndicesString, actionsIdsMap]);

  const visibleIndicesSet = useMemo(() => {
    return new Set(visibleIndicesArray);
  }, [visibleIndicesArray]);

  const visibleActions = useMemo(() => {
    return filteredActions.filter((_, index) => visibleIndicesSet.has(index));
  }, [filteredActions, visibleIndicesSet]);

  const actionsWithTransitions = useTransition(
    visibleActions,
    (action) => String(action._id),
    {
      from: { transform: 'translate3d(0,-40px,0)', opacity: 0 },
      enter: { transform: 'translate3d(0,0px,0)', opacity: 1 },
      leave: { transform: 'translate3d(0,-40px,0)', opacity: 0 },
    },
  );
  const redCornereOutcome = useMemo(
    () =>
      outcomeOfCorner(
        fight.fightersOutcome,
        { newId: fight.redCornerId, legacyId: fight.legacyRedCornerId },
        0,
      ),
    [fight.fightersOutcome, fight.redCornerId, fight.legacyRedCornerId],
  );
  const blueCornereOutcome = useMemo(
    () =>
      outcomeOfCorner(
        fight.fightersOutcome,
        { newId: fight.blueCornerId, legacyId: fight.legacyBlueCornerId },
        1,
      ),
    [fight.fightersOutcome, fight.blueCornerId, fight.legacyBlueCornerId],
  );

  const [selectedOption, setSelectedOption] = useState<{
    value: number;
    label: number;
  }>({
    value: fight.currentRound,
    label: fight.currentRound,
  });

  useEffect(() => {
    setSelectedOption({
      value: fight.currentRound,
      label: fight.currentRound,
    });
  }, [fight.currentRound]);

  const officialTimeVal = useRef() as React.MutableRefObject<HTMLInputElement>;

  const [scoreRedCornerTemp, setScoreRedCornerTemp] = useState(0);
  const currentScoreRedCorner = useRef(0);

  const [scoreBlueCornerTemp, setScoreBlueCornerTemp] = useState(0);
  const currentScoreBlueCorner = useRef(0);

  if (
    fight.fightType === 'WRESTLING' ||
    fight.fightType === 'SUBMISSION_GRAPPLING'
  ) {
    // setInitialScore();
    currentScoreRedCorner.current = redCornereOutcome?.score || 0;
    currentScoreBlueCorner.current = blueCornereOutcome?.score || 0;
  }

  const checkControl = useCallback(async () => {
    // Leitura síncrona: o domínio pode ter acabado de mudar por tecla/clique.
    const current = getFight();

    if (current.currentDomain) {
      const isRedDomain = cornerOfDomainKey(current.currentDomain) === 'red';
      const recordData = {
        fightId: toLegacyFightId(fight.legacyId),
        fightNewId: fight.id,
        round: current.currentRound,
        stance: current.currentStance,
        domain: true,
        roundTime: getRoundTimeInSeconds(),
        name: 'controlEnded',
        authorId: isRedDomain
          ? fight.legacyRedCornerId
          : fight.legacyBlueCornerId,
        targetId: isRedDomain
          ? fight.legacyBlueCornerId
          : fight.legacyRedCornerId,
        authorNewId: isRedDomain
          ? fight.redCornerId
          : fight.blueCornerId,
        targetNewId: isRedDomain
          ? fight.blueCornerId
          : fight.redCornerId,
        corner: isRedDomain
          ? 'red'
          : 'blue',
        eventId: fight.oneEventId || fight.eventId,
        boutId: fight.oneFightId,
      };

      await sendAction('record', {
        promotionId: fight.promotionId,
        data: recordData,
      });

      updateFight({
        currentDomain: null,
        currentStance: 'standing',
      });
    }
  }, [fight, getFight, getRoundTimeInSeconds, updateFight]);

  // Handler do fim de luta
  const handleEndFight = useCallback(async () => {
    if (winner === undefined || winner?.value === undefined) return;

    // Dois cliques no botão gravavam duas `fightResult`: o segundo entrava
    // antes de o primeiro ter `_id` para o guard de update.
    if (savingResult.current) return;
    savingResult.current = true;
    setIsSavingResult(true);

    // Await: sem ele o `controlEnded` podia ser gravado depois do fim da luta.
    await checkControl();

    // O Select entrega o UUID do canto (ou `null` para empate). Decidir pelo
    // legado quebrava em lutas sem mapeamento: os dois cantos ficavam com o
    // mesmo id e o empate caía no primeiro `case`.
    const resolved = resolveWinner(winner.value, fight);

    if (!resolved) {
      savingResult.current = false;
      setIsSavingResult(false);
      toast.error('Não foi possível identificar o vencedor selecionado.');
      return;
    }

    const {
      corner: winnerCorner,
      winnerId,
      winnerName,
      winnerNewId: winnerIdV2,
      loserId,
      loserNewId: loserIdV2,
    } = resolved;
    const officialTime = officialTimeVal.current.value;

    // A lista de actions é a fonte autoritativa: o estado local pode ser uma
    // cópia otimista ainda sem `_id`. Sem esta busca, editar o resultado
    // gravava uma `fightResult` nova em vez de atualizar a existente.
    const existingResult = resultAction?._id
      ? resultAction
      : (actions.find((act) => act.name === 'fightResult') as
          | FightAction
          | undefined) ?? resultAction;

    if (existingResult?._id) {
      const updateAction = {
        ...existingResult,
        authorId: winnerId,
        authorNewId: winnerIdV2 || undefined,
        targetId: loserId,
        targetNewId: loserIdV2 || undefined,
        corner: winnerCorner === 'blue' ? 'blue' : 'red',
        extraFields: {
          winnerName,
          winnerId,
          winnerNewId: winnerIdV2,
          finishType: getFinishTypeLabel(finishType?.value),
          finishTypeCode: finishType?.value,
          officialTime,
        },
      };

      await sendAction('update', {
        promotionId: fight.promotionId,
        data: updateAction,
      });

      setResultAction(updateAction);
    } else {
      const action = {
        fightId: toLegacyFightId(fight.legacyId),
        fightNewId: fight.id,
        round: fight.currentRound,
        stance: 'standing',
        domain: null,
        roundTime: getRoundTimeInSeconds(),
        name: 'fightResult',
        authorId: winnerId,
        targetId: loserId,
        authorNewId: winnerIdV2 || undefined,
        targetNewId: loserIdV2 || undefined,
        eventId: fight.oneEventId || fight.eventId,
        boutId: fight.oneFightId,
        corner: winnerCorner === 'blue' ? 'blue' : 'red',
        extraFields: {
          winnerName,
          winnerId,
          winnerNewId: winnerIdV2,
          finishType: getFinishTypeLabel(finishType?.value),
          finishTypeCode: finishType?.value,
          officialTime,
        },
      };

      const sent = await sendAction('record', {
        promotionId: fight.promotionId,
        data: action,
      });

      // O ack do websocket devolve o documento persistido: adotá-lo dá o `_id`
      // na hora, então uma segunda edição já entra pelo caminho de update.
      // Sem ack (transporte legado), fica a cópia local mesmo.
      setResultAction((sent.action as FightAction) ?? action);
    }
    updateFight({
      status: 'finish',
      winner: winnerIdV2,
      result: finishType?.value,
    });

    const fightRequest: FightRequest = {
      id: fight.id,
      winner: winnerIdV2 || null,
      result: finishType?.value,
      finishedAt:
        officialTime !== '' ? officialTime : translateCurrentRoundTime(),
      finishedAtRound: fight.currentRound,
    };

    // O resultado da luta vai primeiro e sozinho: antes ele era a última
    // chamada de uma cadeia de PATCHs, e qualquer falha em fighters/cartels
    // fazia o resultado nunca chegar na luta.
    try {
      await fightApiV2.patch(`/fights/${fight.id}`, fightRequest);
    } catch (error) {
      toast.error(`Erro ao atualizar o resultado da luta: ${error}`);
    }

    /** Fazer corrigir os valores no caso de atualização de resultado */
    try {
      const redCornerResponse = await fightApiV2.get(
        `/fighters/${fight.redCornerId}`,
      );
      const blueCornerResponse = await fightApiV2.get(
        `/fighters/${fight.blueCornerId}`,
      );

      if (redCornerResponse.data && blueCornerResponse.data) {
        const finishCategory = getFinishCategory(finishType?.value);

        const redCornerRequest: CornerRecord = {
          id: fight.redCornerId,
        };

        const blueCornerRequest: CornerRecord = {
          id: fight.blueCornerId,
        };

        switch (winnerCorner) {
          case 'red':
            redCornerRequest.wins = redCornerResponse.data.wins + 1;
            blueCornerRequest.losses = blueCornerResponse.data.losses + 1;
            if (finishCategory === 'kotko') {
              redCornerRequest.winsKoTko =
                (redCornerResponse.data.winsKoTko ?? 0) + 1;
              blueCornerRequest.lossesKoTko =
                (blueCornerResponse.data.lossesKoTko ?? 0) + 1;
            } else if (finishCategory === 'submission') {
              redCornerRequest.winsSubmission =
                (redCornerResponse.data.winsSubmission ?? 0) + 1;
              blueCornerRequest.lossesSubmission =
                (blueCornerResponse.data.lossesSubmission ?? 0) + 1;
            } else if (finishCategory === 'decision') {
              redCornerRequest.winsDecision =
                (redCornerResponse.data.winsDecision ?? 0) + 1;
              blueCornerRequest.lossesDecision =
                (blueCornerResponse.data.lossesDecision ?? 0) + 1;
            }
            break;
          case 'blue':
            redCornerRequest.losses = redCornerResponse.data.losses + 1;
            blueCornerRequest.wins = blueCornerResponse.data.wins + 1;
            if (finishCategory === 'kotko') {
              redCornerRequest.lossesKoTko =
                (redCornerResponse.data.lossesKoTko ?? 0) + 1;
              blueCornerRequest.winsKoTko =
                (blueCornerResponse.data.winsKoTko ?? 0) + 1;
            } else if (finishCategory === 'submission') {
              redCornerRequest.lossesSubmission =
                (redCornerResponse.data.lossesSubmission ?? 0) + 1;
              blueCornerRequest.winsSubmission =
                (blueCornerResponse.data.winsSubmission ?? 0) + 1;
            } else if (finishCategory === 'decision') {
              redCornerRequest.lossesDecision =
                (redCornerResponse.data.lossesDecision ?? 0) + 1;
              blueCornerRequest.winsDecision =
                (blueCornerResponse.data.winsDecision ?? 0) + 1;
            }
            break;
          case 'draw':
            redCornerRequest.draws = redCornerResponse.data.draws + 1;
            blueCornerRequest.draws = blueCornerResponse.data.draws + 1;
            break;
          default:
            break;
        }

        // update red corner history
        await fightApiV2.patch(
          `/fighters/${fight.redCornerId}`,
          redCornerRequest,
        );

        // update blue corner history
        await fightApiV2.patch(
          `/fighters/${fight.blueCornerId}`,
          blueCornerRequest,
        );

        const redCartel = redCornerResponse.data.cartels?.find(
          (c: any) => c.sport === fight.fightType,
        );
        const blueCartel = blueCornerResponse.data.cartels?.find(
          (c: any) => c.sport === fight.fightType,
        );

        if (redCartel) {
          const redCartelRequest: any = { id: redCartel.id };
          switch (winnerCorner) {
            case 'red':
              redCartelRequest.wins = ((redCartel.wins ?? 0) + 1).toString();
              if (finishCategory === 'kotko')
                redCartelRequest.winsKoTko = (
                  (redCartel.winsKoTko ?? 0) + 1
                ).toString();
              else if (finishCategory === 'submission')
                redCartelRequest.winsSubmission = (
                  (redCartel.winsSubmission ?? 0) + 1
                ).toString();
              else if (finishCategory === 'decision')
                redCartelRequest.winsDecision = (
                  (redCartel.winsDecision ?? 0) + 1
                ).toString();
              break;
            case 'blue':
              redCartelRequest.losses = (
                (redCartel.losses ?? 0) + 1
              ).toString();
              if (finishCategory === 'kotko')
                redCartelRequest.lossesKoTko = (
                  (redCartel.lossesKoTko ?? 0) + 1
                ).toString();
              else if (finishCategory === 'submission')
                redCartelRequest.lossesSubmission = (
                  (redCartel.lossesSubmission ?? 0) + 1
                ).toString();
              else if (finishCategory === 'decision')
                redCartelRequest.lossesDecision = (
                  (redCartel.lossesDecision ?? 0) + 1
                ).toString();
              break;
            case 'draw':
              redCartelRequest.draws = ((redCartel.draws ?? 0) + 1).toString();
              break;
            default:
              break;
          }
          await fightApiV2.patch(`/cartels/${redCartel.id}`, redCartelRequest);
        }

        if (blueCartel) {
          const blueCartelRequest: any = { id: blueCartel.id };
          switch (winnerCorner) {
            case 'red':
              blueCartelRequest.losses = (
                (blueCartel.losses ?? 0) + 1
              ).toString();
              if (finishCategory === 'kotko')
                blueCartelRequest.lossesKoTko = (
                  (blueCartel.lossesKoTko ?? 0) + 1
                ).toString();
              else if (finishCategory === 'submission')
                blueCartelRequest.lossesSubmission = (
                  (blueCartel.lossesSubmission ?? 0) + 1
                ).toString();
              else if (finishCategory === 'decision')
                blueCartelRequest.lossesDecision = (
                  (blueCartel.lossesDecision ?? 0) + 1
                ).toString();
              break;
            case 'blue':
              blueCartelRequest.wins = ((blueCartel.wins ?? 0) + 1).toString();
              if (finishCategory === 'kotko')
                blueCartelRequest.winsKoTko = (
                  (blueCartel.winsKoTko ?? 0) + 1
                ).toString();
              else if (finishCategory === 'submission')
                blueCartelRequest.winsSubmission = (
                  (blueCartel.winsSubmission ?? 0) + 1
                ).toString();
              else if (finishCategory === 'decision')
                blueCartelRequest.winsDecision = (
                  (blueCartel.winsDecision ?? 0) + 1
                ).toString();
              break;
            case 'draw':
              blueCartelRequest.draws = (
                (blueCartel.draws ?? 0) + 1
              ).toString();
              break;
            default:
              break;
          }
          await fightApiV2.patch(
            `/cartels/${blueCartel.id}`,
            blueCartelRequest,
          );
        }
      }
    } catch (error) {
      toast.warn(
        `Resultado salvo, mas o cartel dos lutadores não foi atualizado: ${error}`,
      );
    } finally {
      savingResult.current = false;
      setIsSavingResult(false);
      setIsOpen(false);
    }
  }, [
    winner,
    checkControl,
    officialTimeVal,
    resultAction,
    actions,
    updateFight,
    finishType,
    fight,
    token,
    getRoundTimeInSeconds,
    translateCurrentRoundTime,
  ]);

  const handleOpenRoundModal = async (e: any) => {
    if (!e.value) {
      setRoundIsOpen(true);
    } else {
      updateFight({ currentRound: e.value });
      setSelectedOption(e);
    }
  };

  const handleCloseRoundModal = async (e: any) => {
    setRoundIsOpen(false);
  };
  // Handler do fim da luta
  const handleRoundsChange = async (e: any) => {

    await checkControl();
    const recordData = {
      fightId: toLegacyFightId(fight.legacyId),
      fightNewId: fight.id,
      round: fight.currentRound,
      stance: 'standing',
      domain: null,
      roundTime: getRoundTimeInSeconds(),
      name: 'roundEnd',
      authorId: fight.legacyRedCornerId,
      targetId: fight.legacyBlueCornerId,
      corner: 'red',
      eventId: fight.oneEventId || fight.eventId,
      boutId: fight.oneFightId,
      authorNewId: fight.redCornerId,
      targetNewId: fight.blueCornerId,
    };

    // socket?.emit('record', token, recordData);

    await sendAction('record', {
      promotionId: fight.promotionId,
      data: recordData,
    });
    // debugger;
    // const totalRound =
    //   fight.currentRound === fight.totalRound
    //     ? fight.totalRound + 1
    //     : fight.totalRound;
    // const currentRound = fight.currentRound + 1;
    updateFight({
      // currentRound,
      // totalRound,
      currentMinutes: 0,
      currentSeconds: 0,
      roundStatus: undefined,
      currentDomain: null,
      currentStance: 'standing',
    });

    // setSelectedOption({
    //   value: currentRound,
    //   label: currentRound,
    // });
    dispatchFight({
      type: 'time',
      time: {
        currentMinutes: 0,
        currentSeconds: 0,
      },
    });
    setRoundIsOpen(false);
  };

  // Handlers da modal
  const handleOpenModal = () => {
    setIsOpen(true);
  };

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  // Reset do scout da luta — mesmo modal da tecla '6'.
  const handleCancelScout = () => {
    openResetModal();
  };

  // Handlers de score. Apenas para WRESTLING
  const emitScore = async (value: number, isRedCorner: boolean) => {
    const recordData = {
      fightId: toLegacyFightId(fight.legacyId),
      fightNewId: fight.id,
      round: fight.currentRound,
      stance: fight.currentStance,
      domain: false,
      roundTime: getRoundTimeInSeconds(),
      name: 'score',
      value,
      corner: isRedCorner ? 'red' : 'blue',
      boutId: fight.oneFightId,
      eventId: fight.oneEventId || fight.eventId,
      authorId: isRedCorner
        ? fight.legacyRedCornerId
        : fight.legacyBlueCornerId,
      targetId: isRedCorner
        ? fight.legacyBlueCornerId
        : fight.legacyRedCornerId,
      authorNewId: isRedCorner ? fight.redCornerId : fight.blueCornerId,
      targetNewId: isRedCorner ? fight.blueCornerId : fight.redCornerId,
    };

    await sendAction('record', {
      promotionId: fight.promotionId,
      data: recordData,
    });
  };
  const handleTempScoreRed = function (value: string) {
    setScoreRedCornerTemp(parseInt(value, 10));
  };
  const handleScoreRed = () => {
    emitScore(scoreRedCornerTemp, true);
    setScoreRedCornerTemp(0);
  };

  const handleTempScoreBlue = function (value: string) {
    setScoreBlueCornerTemp(parseInt(value, 10));
  };

  const handleScoreBlue = function () {
    emitScore(scoreBlueCornerTemp, false);
    setScoreBlueCornerTemp(0);
  };

  const handleRedCornerColor = useCallback((color: ColorResult) => {
    setRedCornerColor(color.rgb);
  }, []);

  const handleBlueCornerColor = useCallback((color: ColorResult) => {
    setBlueCornerColor(color.rgb);
  }, []);

  const domainSwitch = () => {
    switch (fight.currentDomain) {
      case '3':
      case '4':
      case '5':
        return 'current-domain true-color';
      case '9':
      case '8':
      case '7':
        return 'current-domain true-color';
      default:
        return 'current-domain neutral-color';
    }
  };
  const stanceSwitch = () => {
    let str = '';
    switch (fight.currentStance) {
      case 'standing':
        str = 'current-stance ';
        break;
      case 'fence':
        str = 'current-stance ';
        break;
      case 'ground':
        str = 'current-stance ';
        break;
      default:
        str = 'current-stance ';
    }
    switch (fight.currentDomain) {
      case '3':
      case '4':
      case '5':
        str += 'red';
        break;
      case '9':
      case '8':
      case '7':
        str += 'blue';
        break;
      default:
        str += 'neutral';
        break;
    }
    return str;
  };

  const getListRounds = () => {
    const rounds = [];
    // eslint-disable-next-line no-plusplus
    for (let i = 1; i <= (fight.totalRound || 1); i++) {
      rounds.push({ value: i, label: i });
    }
    rounds.push({ value: 0, label: 'Finalizar round' });
    return rounds;
  };

  useEffect((): any => {
    updateFight({ id: match.params.id, loading: true });

    return () => {
      // Reset dos hooks ao sair da página
      dispatchAction({ type: 'reset' });
      dispatchFight({
        type: 'fetch',
        init: {
          ...initData,
          loading: true,
        },
      });
    };
  }, [match.params.id, updateFight, dispatchAction, dispatchFight]);

  useEffect((): any => {
    dispatchHeader({
      title: 'Scout',
      eventName: fight.eventName || '',
      leftBg: {
        r: 107,
        g: 121,
        b: 151,
        a: 1,
      },
      rightBg: {
        r: 228,
        g: 233,
        b: 242,
        a: 1,
      },
      hasLogout: false,
      isScout: true,
    });
  }, [fight.eventName, dispatchHeader]);

  useEffect((): any => {
    const action = actions.find(
      (act) => act.name === 'fightResult',
    ) as FightAction;

    if (action) {
      setResultAction(action);
      return;
    }

    // A lista não tem resultado. Só limpar quando a cópia local já existia no
    // servidor (tinha `_id`) e sumiu — reset ou revoke. Uma cópia sem `_id` é
    // um envio em andamento: apagá-la fazia o guard perder a referência e o
    // salvamento seguinte gravar uma segunda `fightResult`.
    setResultAction((current) =>
      current?._id ? ({} as FightAction) : current,
    );
  }, [actions]);

  useEffect((): any => {
    // `{}` é o estado inicial/limpo; só uma `fightResult` de verdade restaura.
    if (resultAction?.name !== 'fightResult') {
      // Sem resultado gravado não há vencedor a restaurar. Antes o estado virava
      // um `Option` com `value: undefined`, e era só por isso que `handleEndFight`
      // precisava do guard contra `undefined`.
      setWinner(undefined);
      setFinishType(undefined);
      return;
    }

    // O UUID é a chave; o helper traduz o id legado das actions antigas.
    const restoredNewId = winnerNewIdFromAction(resultAction, fight);

    if (restoredNewId === undefined) {
      // Resultado gravado que não permite identificar o vencedor: melhor pedir
      // uma nova escolha do que reabrir mostrando "Draw" por engano.
      setWinner(undefined);
    } else if (restoredNewId === null) {
      setWinner({ value: null, label: 'Draw' });
    } else {
      setWinner({
        value: restoredNewId,
        label: resultAction.extraFields?.winnerName,
      });
    }
    setFinishType(
      toFinishTypeOption(
        resultAction?.extraFields?.finishTypeCode ??
          resultAction?.extraFields?.finishType,
      ),
    );
  }, [resultAction, fight]);

  useEffect((): any => {
    let cancelled = false;

    // Sem estar na sala, o scout não recebe nem o broadcast nem o eco dos
    // co-scouts — então o join é tentado de novo, com backoff, até entrar.
    const joinEventRoom = async (attempt = 0): Promise<void> => {
      if (cancelled || !isConnectedV2 || !fight.eventId) return;

      const retry = () => {
        if (cancelled || attempt >= 5) return;
        const delay = Math.min(1000 * 2 ** attempt, 15000);
        setTimeout(() => joinEventRoom(attempt + 1), delay);
      };

      try {
        // Manda o id do evento: o servidor resolve o nome da sala, valida a
        // autorização e coloca o scout também na sala privada de scouts.
        const response = await joinEventWithAckV2(fight.eventId);
        if (response?.success) return;

        const error = response?.error ?? '';
        const isTimeout = error.includes('timeout') || error.includes('timed out');
        const isDisconnected =
          error.includes('disconnected') || error.includes('disconnect');

        if (isTimeout) {
          console.warn(
            `[Scout] Timeout ao entrar na sala ${fight.eventId}, tentando novamente...`,
          );
          retry();
        } else if (!isDisconnected) {
          // Desconexão é esperada no logout; o resto é erro de verdade.
          toast.error(
            `Erro ao conectar websocket na sala ${fight.eventId}: ${error}`,
          );
          retry();
        }
      } catch (error) {
        const errorMessage =
          error instanceof Error ? error.message : String(error);
        const isTimeout =
          errorMessage.includes('timeout') || errorMessage.includes('timed out');
        const isDisconnected =
          errorMessage.includes('disconnected') ||
          errorMessage.includes('disconnect');

        if (isTimeout) {
          console.warn(`[Scout] Timeout ao conectar websocket: ${errorMessage}`);
          retry();
        } else if (!isDisconnected) {
          toast.error(
            `Erro ao conectar websocket na sala no mike-v2: ${errorMessage}`,
          );
          retry();
        }
      }
    };

    joinEventRoom();

    return () => {
      cancelled = true;
    };
  }, [isConnectedV2, fight.eventId, joinEventWithAckV2]);

  return (
    <Container>
      <ColorContainer className="scout-section" isRedCorner>
        {redCornereOutcome && (
          <StatContainer
            color={redCornerColor}
            outcome={redCornereOutcome}
            handleChange={handleRedCornerColor}
            isRedCorner
          />
        )}
      </ColorContainer>

      <FightContainer className="scout-section">
        <FightDataContainer
          rr={redCornerColor.r}
          br={blueCornerColor.r}
          rg={redCornerColor.g}
          bg={blueCornerColor.g}
          rb={redCornerColor.b}
          bb={blueCornerColor.b}
        >
          <Stopwatch
            start={fight.roundStatus === 'started'}
            pause={fight.roundStatus === 'paused'}
            style={{ display: 'none' }}
          />

          <span className="round-watch">{translateCurrentRoundTime()}</span>

          <div className="status">
            {fight.loading ? (
              <SkeletonTheme color="#1111" highlightColor="#d3d3d3">
                <Skeleton height={15} width={200} />
              </SkeletonTheme>
            ) : (
              <span>{labels[fight.status]}</span>
            )}
          </div>
          <div className="domain">
            {fight.fightType === 'WRESTLING' ||
            fight.fightType === 'SUBMISSION_GRAPPLING' ? (
              <div className="score-container">
                <div className="red-score">
                  <div>Score: {currentScoreRedCorner.current}</div>
                  <div className="score-input">
                    <input
                      type="number"
                      value={scoreRedCornerTemp}
                      placeholder="0"
                      onChange={(e) => {
                        handleTempScoreRed(e.target.value);
                      }}
                    />
                  </div>
                  <Button
                    style={{
                      background: 'rgba(1, 128, 199, 1)',
                      color: '#FFF',
                    }}
                    onClick={handleScoreRed}
                  >
                    Enviar
                  </Button>
                </div>
                <div className="blue-score">
                  <div>Score: {currentScoreBlueCorner.current}</div>
                  <div className="score-input">
                    <input
                      type="number"
                      value={scoreBlueCornerTemp}
                      placeholder="0"
                      onChange={(e) => {
                        handleTempScoreBlue(e.target.value);
                      }}
                    />
                  </div>
                  <Button
                    style={{
                      background: 'rgba(1, 128, 199, 1)',
                      color: '#FFF',
                    }}
                    onClick={handleScoreBlue}
                  >
                    Enviar
                  </Button>
                </div>
              </div>
            ) : (
              <span className={stanceSwitch()}>
                {labels[fight.currentStance]}
              </span>
            )}

            {fight.currentDomain ? (
              <span className={domainSwitch()}>
                {fight.currentDomain ? 'True' : 'Neutral'}
              </span>
            ) : (
              <span className="current-domain neutral-color">Neutral</span>
            )}
          </div>

          <div className="select-round">
            <Select
              placeholder="Select round"
              onChange={(e) => handleOpenRoundModal(e)}
              options={getListRounds()}
              value={selectedOption}
            />
          </div>

          <div className="badges">
            <Badge bgColor={blueCornerColor} color="#fff">
              corner blue
            </Badge>
            <Badge bgColor={redCornerColor} color="#fff">
              corner red
            </Badge>
            <Badge bgColor={groundColor} color="#fff">
              ground
            </Badge>
            <Badge bgColor={standingColor} color="#2A2A2A">
              standing
            </Badge>
            <Badge bgColor={fenceColor} color="#fff">
              fence
            </Badge>
            <Badge bgColor={trueColor} color="#2A2A2A">
              true
            </Badge>
            <Badge bgColor={neutroColor} color="#fff">
              neutro
            </Badge>
            <Badge bgColor={falseColor} color="#fff">
              false
            </Badge>
          </div>

          <Modal
            isOpen={modalIsOpen}
            onRequestClose={handleCloseModal}
            style={customStyles}
            contentLabel="Fight Result Modal"
          >
            <ModalTitle>
              <div className="title">
                <h2>FIGHT RESULT</h2>
              </div>
            </ModalTitle>

            <ModalContent>
              <Select
                placeholder="Fight Winner"
                onChange={(e) => setWinner(e)}
                value={winner}
                options={[
                  { value: null, label: 'Draw' },
                  {
                    // UUID, não o id legado: em lutas sem mapeamento os dois
                    // cantos ficavam com o mesmo `value` e viravam a mesma opção.
                    value: fight.redCornerId,
                    label: fight.redCornerName,
                  },
                  {
                    value: fight.blueCornerId,
                    label: fight.blueCornerName,
                  },
                ]}
              />
              <Select
                placeholder="Finish Type"
                onChange={(e) => setFinishType(e)}
                value={finishType}
                options={getFinishTypesForSport(fight.fightType)}
              />
            </ModalContent>

            <ModalContent>
              <div className="official-time">
                <IMaskInput
                  type="text"
                  className="time-input"
                  inputRef={officialTimeVal}
                  placeholder="Official time"
                  mask="00:00"
                  value={
                    officialTimeVal?.current?.value ||
                    resultAction?.extraFields?.officialTime
                  }
                />
              </div>
            </ModalContent>

            <ModalContent>
              <Button
                style={{
                  width: '184px',
                  height: '46px',
                  color: 'rgba(1, 128, 199, 1)',
                }}
                onClick={handleCloseModal}
              >
                Fechar
              </Button>
              <Button
                style={{
                  width: '184px',
                  height: '46px',
                  background: 'rgba(1, 128, 199, 1)',
                  color: '#FFF',
                }}
                onClick={handleEndFight}
                disabled={isSavingResult}
              >
                {isSavingResult ? 'Salvando...' : 'Inserir resultado'}
              </Button>
            </ModalContent>
          </Modal>

          <Modal
            isOpen={modalRoundIsOpen}
            onRequestClose={handleCloseRoundModal}
            style={customStyles}
            contentLabel="Fight Round Change Modal"
          >
            <ModalTitle>
              <div className="title">
                <h2>FINALIZAR ROUND</h2>
              </div>
            </ModalTitle>
            <ModalContent>
              <div className="content">
                Finalizar round e avançar para o próximo?
              </div>
            </ModalContent>
            <ModalContent>
              <Button
                style={{
                  width: '184px',
                  height: '46px',
                  color: 'rgba(1, 128, 199, 1)',
                }}
                onClick={handleCloseRoundModal}
              >
                Cancelar
              </Button>
              <Button
                style={{
                  width: '184px',
                  height: '46px',
                  background: 'rgba(1, 128, 199, 1)',
                  color: '#FFF',
                }}
                onClick={handleRoundsChange}
              >
                Finalizar round
              </Button>
            </ModalContent>
          </Modal>

          <Modal
            isOpen={resetRequested}
            onRequestClose={handleCloseModalReset}
            style={customStyles}
            contentLabel="Fight Reset Modal"
          >
            <ModalTitle>
              <div className="title">
                <h2>RESETAR LUTA</h2>
              </div>
            </ModalTitle>
            <ModalContent>
              <div className="content">
                Deseja realmente resetar a luta? Todas as ações serão excluídas.
              </div>
            </ModalContent>
            <ModalContent>
              <ConfirmCheckbox htmlFor="reset-confirm">
                <input
                  id="reset-confirm"
                  type="checkbox"
                  checked={resetConfirmed}
                  onChange={(e) => setResetConfirmed(e.target.checked)}
                />
                Tenho certeza e desejo continuar
              </ConfirmCheckbox>
            </ModalContent>
            <ModalContent>
              <Button
                style={{
                  width: '184px',
                  height: '46px',
                  color: 'rgba(1, 128, 199, 1)',
                }}
                onClick={handleCloseModalReset}
              >
                Cancelar
              </Button>
              <Button
                disabled={!resetConfirmed}
                style={{
                  width: '184px',
                  height: '46px',
                  background: 'rgba(1, 128, 199, 1)',
                  color: '#FFF',
                  opacity: resetConfirmed ? 1 : 0.5,
                  cursor: resetConfirmed ? 'pointer' : 'not-allowed',
                }}
                onClick={() => emitReset()}
              >
                Resetar luta
              </Button>
            </ModalContent>
          </Modal>

          <Modal
            isOpen={fightEnd}
            onRequestClose={handleCloseModalFightEnd}
            style={customStyles}
            contentLabel="Fight Swap Fighters Modal"
          >
            <ModalTitle>
              <div className="title">
                <h2> Decidir fim da luta</h2>
              </div>
            </ModalTitle>

            <ModalContent>
              <div className="inverter-lutadores content">
                Clique no tipo de final de luta ocorrido
              </div>
            </ModalContent>

            <ModalContent>
              <Button
                style={{
                  width: '184px',
                  height: '46px',
                  color: 'rgba(1, 128, 199, 1)',
                }}
                onClick={handleCloseModalFightEnd}
              >
                Fechar
              </Button>
              <Button
                style={{
                  width: '184px',
                  height: '46px',
                  background: 'rgba(1, 128, 199, 1)',
                  color: '#FFF',
                }}
                onClick={() => emitFightEnd('Stoppage')}
              >
                Via rápida
              </Button>
              <Button
                style={{
                  width: '184px',
                  height: '46px',
                  background: 'rgba(1, 128, 199, 1)',
                  color: '#FFF',
                }}
                onClick={() => emitFightEnd('Decision')}
              >
                Decisão
              </Button>
            </ModalContent>
          </Modal>
        </FightDataContainer>

        <LogsContainer>
          <div className="prev" />

          {fight.loading && (
            <SkeletonTheme color="#1111" highlightColor="#d3d3d3">
              <Skeleton height={20} width={1000} count={10} />
            </SkeletonTheme>
          )}

          {!fight.loading && (
            <Swiper
              modules={[Scrollbar, Mousewheel, Navigation, FreeMode]}
              grabCursor
              slidesPerView="auto"
              autoHeight
              navigation={{
                enabled: true,
                nextEl: '.next',
                prevEl: '.prev',
              }}
              spaceBetween={0}
              direction="vertical"
              className="mySwiper"
              freeMode={{
                enabled: true,
              }}
              mousewheel
              scrollbar={{
                enabled: true,
                verticalClass: 'custom-scrollbar',
                draggable: true,
                dragSize: 80,
              }}
            >
              <div>
                {filteredActions.length === 0 && (
                  <SwiperSlide>
                    <LogLine
                      isFinishedFight={isFinishedFight}
                      key="0"
                      action={{} as FightAction}
                      blueCornerColor={blueCornerColor}
                      redCornerColor={redCornerColor}
                    />
                  </SwiperSlide>
                )}
                {filteredActions.map((action, index) => {
                  const isVisible = visibleIndicesSet.has(index);
                  const transitionData = isVisible
                    ? actionsWithTransitions.find(
                        ({ item }) => item._id === action._id,
                      )
                    : null;

                  if (!isVisible) {
                    return (
                      <SwiperSlide key={action._id || `placeholder-${index}`}>
                        <div
                          ref={setItemRef(index)}
                          style={{ minHeight: '60px', width: '100%' }}
                        />
                      </SwiperSlide>
                    );
                  }

                  return (
                    <SwiperSlide key={action._id || `action-${index}`}>
                      <div ref={setItemRef(index)}>
                        <LogLine
                          isFinishedFight={isFinishedFight}
                          key={action._id}
                          action={action}
                          style={transitionData?.props}
                          blueCornerColor={blueCornerColor}
                          redCornerColor={redCornerColor}
                        />
                      </div>
                    </SwiperSlide>
                  );
                })}
              </div>
            </Swiper>
          )}
          {/* <div>AQUI FICA SETA PRA BAIXO</div> */}

          <div className="next fa fa-next" />
        </LogsContainer>

        <div className="buttons-container">
          <Button
            style={{
              width: '184px',
              height: '46px',
              color: 'rgba(1, 128, 199, 1)',
            }}
            onClick={() => handleCancelScout()}
          >
            Cancelar
          </Button>
          <Button
            style={{
              width: '184px',
              height: '46px',
              background: 'rgba(1, 128, 199, 1)',
              color: '#FFF',
            }}
            onClick={() => handleOpenModal()}
          >
            Inserir resultado
          </Button>
        </div>
      </FightContainer>

      <ColorContainer className="scout-section" isRedCorner={false}>
        {blueCornereOutcome && (
          <StatContainer
            color={blueCornerColor}
            outcome={blueCornereOutcome}
            isRedCorner={false}
            handleChange={handleBlueCornerColor}
          />
        )}
      </ColorContainer>
    </Container>
  );
};

export default Stats;
function joinRoomV2(roomName: string) {
  throw new Error('Function not implemented.');
}
